export const getScrollbarWidth = function () {
  let oP = document.createElement('p')
  let styles = { width: '100px', height: '100px', overflowY: 'scroll' }
  for (let i in styles) {
    oP.style[i] = styles[i]
  }
  document.body.appendChild(oP)
  let scrollbarWidth = oP.offsetWidth - oP.clientWidth
  oP.remove()

  return scrollbarWidth
}

export const getContentHeight = function (other) {
  return document.body.offsetHeight - other
}

export const getContentWidth = function (other) {
  return document.body.offsetWidth - other
}

export const getFontSize = function (size) {
  if (window.screen.availWidth < 1920) {
    let scale = window.screen.availWidth * 1.0 / 1920
    return size * scale
  } else {
    return size
  }
}

// 判断是否是pc浏览器
export const browserPC = () => {
  let matchs = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
  if (matchs) {
    return (matchs.length === 0)
  }
  return true
}

export const getIEVersion = () => {
  let userAgent = navigator.userAgent // 取得浏览器的userAgent字符串
  let isIE = userAgent.indexOf('compatible') > -1 && userAgent.indexOf('MSIE') > -1 // 判断是否IE<11浏览器
  let isEdge = userAgent.indexOf('Edge') > -1 && !isIE // 判断是否IE的Edge浏览器
  let isIE11 = userAgent.indexOf('Trident') > -1 && userAgent.indexOf('rv:11.0') > -1
  if (isIE) {
    let reIE = new RegExp('MSIE (\\d+\\.\\d+);')
    reIE.test(userAgent)
    let fIEVersion = parseFloat(RegExp['$1'])
    if (fIEVersion < 7) {
      return 6
    } else {
      return fIEVersion
    }
  } else if (isEdge) {
    return 'edge'// edge
  } else if (isIE11) {
    return 11 // IE11
  } else {
    return -1// 不是ie浏览器
  }
}

// 判断系统类型
export const getOSVersion = () => {
  let agent = navigator.userAgent.toLowerCase()
  let isMac = /macintosh|mac os x/i.test(agent)
  if (isMac) {
    return 'mac'
  } else {
    let os = 'win'
    if (agent.indexOf('win32') >= 0 || agent.indexOf('wow32') >= 0) {
      os += ' win-32'
    } else if (agent.indexOf('win64') >= 0 || agent.indexOf('wow64') >= 0) {
      os += ' win-64'
    }
    return os
  }
}

// 判断文档body的class
export const setBodyClass = (id) => {
  let ieInfo = getIEVersion()
  let app = document.getElementById(id)
  let body = app.parentElement
  let className = body.className ? body.className : 'ts'
  if (ieInfo !== -1) {
    className += ' ie-browser version-' + ieInfo
  }
  className += ' ' + getOSVersion()
  body.className = className
  return body
}

/* eslint-disable */
export const flashChecker = () => {
  if (getIEVersion() !== 9) return false // 限制在IE9检测 YuAng
  let hasFlash = 0　// 是否安装了flash
  let flashVersion = 0 // flash版本
  try {
    if (document.all) {
      let swf = new ActiveXObject('ShockwaveFlash.ShockwaveFlash')
      if (swf) {
        hasFlash = 1
        let VSwf = swf.GetVariable('$version')
        flashVersion = parseInt(VSwf.split(' ')[1].split(',')[0])
      }
    } else {
      if (navigator.plugins && navigator.plugins.length > 0) {
        let swf = navigator.plugins['Shockwave Flash']
        if (swf) {
          hasFlash = 1
          let words = swf.description.split(' ')
          for (let i = 0; i < words.length; ++i) {
            if (isNaN(parseInt(words[i]))) continue
            flashVersion = parseInt(words[i])
          }
        }
      }
    }
  } catch (e) { }
  return {
    noFlash: hasFlash === 0,
    version: flashVersion,
    site: 'https://www.flash.cn/',
    tip: '您的浏览器未安装Adobe Flash Player插件, 是否确定去其官网下载安装后，再重新上传？'
  }
}
